module.exports = __webpack_public_path__ + "img/swiper4.04ada01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/swiper4.png
// module id = 388
// module chunks = 0